module.exports = __webpack_public_path__ + "img/5-1.743bf210.png";